<template>
  <div>
    <div class="row col-md-12">
      <input
        type="file"
        ref="file"
        id="file"
        accept="application/vnd.ms-excel"
        @change="upload"
      />
    </div>
    <div class="row col-md-12 text-center">
      <div v-for="(item, idx) in types" :key="idx" class="docs">
        <div v-if="files && item.type === files[idx].type" class="docs-item">
          <a :href="files[idx].path" target="_blank"
            ><i class="bi bi-download"></i
          ></a>
          <div class="name">
            {{ ` ${files[idx].type_rus} ${files[idx].name} ` }}
            <div v-if="files[idx].type === 'preorder'" class="nakl">
              файл загружен {{ orderInfo.date_send_preorder }}
            </div>
            <div v-if="files[idx].type === 'invoice'" class="nakl">
              файл загружен {{ orderInfo.date_send_invoice }}
            </div>
            <div v-if="files[idx].type === 'realization'" class="nakl">
              файл загружен {{ orderInfo.date_order_finished }}
            </div>
          </div>
          <a
            href="#"
            v-if="USER_INFO.status === 'admin'"
            @click.prevent="del_doc(files[idx].type, files[idx].name)"
            ><i class="bi bi-trash"></i
          ></a>
          <button
            v-if="files[idx].type === 'preorder' && !orderInfo.date_confirm"
            class="btn btn-sm btn-outline-success confirm shadow-none"
            @click="orderConfirm"
          >
            подтвердить заказ
          </button>
          <div
            v-if="files[idx].type === 'preorder' && orderInfo.date_confirm"
            class="notice"
          >
            <div>подтвержден</div>
            <div>{{ orderInfo.date_confirm }}</div>
          </div>
        </div>
        <div v-else>
          <div v-if="USER_INFO.status === 'admin'">
            <a href="#" @click.prevent="addFile(item.type)"
              >загрузить {{ item.title }}</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { HTTPPOSTFILE, HTTPGET } from "@/api";
import { mapGetters } from "vuex";
export default {
  name: "FileForOrder",
  props: ["orderInfo"],
  computed: {
    ...mapGetters(["USER_INFO"])
  },
  data: () => ({
    uloadFileType: null,
    files: null,
    types: [
      { type: "preorder", title: "предварительный заказ" },
      { type: "realization", title: "реализацию" },
      { type: "invoice", title: "счет" }
    ]
  }),
  mounted() {
    this.get_file();
  },
  methods: {
    addFile(type) {
      this.uloadFileType = type;
      const input = document.getElementById("file");
      input.click();
    },
    upload() {
      let formData = new FormData();
      formData.append(`file`, this.$refs.file.files[0]);
      let data = {
        id: this.$route.params.id,
        type: this.uloadFileType
      };
      formData.append("data", JSON.stringify(data));
      HTTPPOSTFILE({
        url: "/order_zap/upload_file_for_order.php",
        data: formData
      })
        .then(response => {
          if (response.data.error) {
            alert(response.data.error);
          }
        })
        .then(() => {
          document.getElementById("file").value = "";
          this.uloadFileType = null;
          this.get_file();
        })
        .then(() => this.$emit("update"));
    },
    get_file() {
      HTTPGET({
        url: "/order_zap/get_file_order_zap.php",
        params: {
          id: this.$route.params.id
        }
      }).then(response => (this.files = response.data));
    },
    del_doc(type, name) {
      HTTPGET({
        url: "/order_zap/del_file_order_zap.php",
        params: {
          id: this.$route.params.id,
          type,
          name
        }
      })
        .then(() => this.get_file())
        .then(() => this.$emit("update"));
    },
    orderConfirm() {
      HTTPGET({
        url: "/order_zap/confirm_order_zap.php",
        params: {
          id: this.$route.params.id
        }
      }).then(() => this.$emit("update"));
    }
  }
};
</script>
<style lang="scss" scoped>
#file {
  position: absolute;
  top: -1000000px;
  left: -1000000px;
}
a,
.notice,
.name {
  margin-right: 10px;
}
.notice {
  color: #198754;
  font-weight: bold;
}
.docs {
  border-right: 1px solid #dee2e6;
  margin-right: 10px;
}
.confirm {
  font-size: 0.7em;
  margin-right: 10px;
}
.docs-item {
  display: flex;
  flex-direction: row;
}
.nakl {
  font-size: 0.8em;
  color: #007bff;
}
</style>
